import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FiSave } from 'react-icons/fi';
import { notify } from '../../Shared/toast';
// import Button from '../../Shared/Button';
import ProductForm from './shared/ProductForm';

function UpdateProduct() {
  const { productId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);

  const categories = [
    'Grocery', 'Beverages', 'Dairy', 'Meat',
    'Vegetables', 'Fruits', 'Cleaning', 'Others',
  ];

  const units = ['Piece', 'Kg', 'Liter', 'Packet', 'Dozen', 'Box'];

  useEffect(() => {
    const fetchProduct = async () => {
      setIsLoading(true);
      try {
        // Simulate API call to fetch product
        await new Promise((resolve) => { setTimeout(resolve, 1000); });
        const mockProduct = {
          productName: 'Premium Rice',
          productNameBn: 'প্রিমিয়াম চাল',
          category: 'Grocery',
          subCategory: 'Grains',
          barcode: '123456789',
          purchasePrice: '80',
          sellingPrice: '100',
          quantity: '50',
          unit: 'Kg',
          minStockLevel: '10',
          description: 'High quality premium rice',
          image: null, // In real app, this would be the image URL
        };
        setInitialValues(mockProduct);
      } catch (error) {
        notify.error('Failed to load product data');
      } finally {
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      // Simulate API call with submitted values
      notify.success('Submitted values:', values);
      await new Promise((resolve) => { setTimeout(resolve, 1500); resolve(); });
      notify.success('Product updated successfully!');
    } catch (error) {
      notify.error('Failed to update product. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (!initialValues) {
    return <div>Loading product data...</div>;
  }

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white rounded-lg shadow">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">Update Product</h1>
      <ProductForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        isLoading={isLoading}
        categories={categories}
        units={units}
        submitButtonText={(
          <>
            <FiSave className="mr-2" />
            Update Product
          </>
        )}
      />
    </div>
  );
}

export default UpdateProduct;
